import '@babel/polyfill'
import 'mutationobserver-shim'
import { createApp } from 'vue'
import App from './App.vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import './plugins/bootstrap-vue'
import router from './router'

// Import the Bugsnag configuration and plugin
import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'

// Import the Auth0 configuration and plugin
import authConfig from '../auth_config';
import createAuth0Client from '@auth0/auth0-spa-js';
import globalProperties from './globalProperties';

if (process.env.NODE_ENV !== 'development' && location.protocol !== 'https:') {
  location.replace(`https:${location.href.substring(location.protocol.length)}`);
}

Bugsnag.start({
  apiKey: 'c1a5f1ca3ffa87432e359fc5a88b03bd',
  plugins: [new BugsnagPluginVue()],
  releaseStage: process.env.NODE_ENV
});

const bugsnagVue = Bugsnag.getPlugin('vue');

createAuth0Client({
  domain: authConfig.domain,
  client_id: authConfig.clientId,
  redirect_uri: `${window.location.origin}/auth/callback`
}).then(auth0Client => {
  const app = createApp(App);
  // global config
  app.config.globalProperties = globalProperties;
  app.config.globalProperties.auth0Client = auth0Client;
  app.config.globalProperties.$scrollReady = () => {
    window.dispatchEvent(new Event('scroll-ready'))
  }
  sessionStorage.clear();

  router.beforeEach((to, from, next) => {
    if (to.meta.requiresAuth) {
      auth0Client.isAuthenticated().then(isAuthenticated => {
        isAuthenticated ? next() : auth0Client.loginWithRedirect()
      })
    } else if (to.path == "/auth/callback") {
      const params = new URLSearchParams(document.location.search)
      const error = params.get("error");

      if (error) {
         // something went wrong with authorization, i.e: bad groups setup
        router.replace("/auth/failed")
        console.error(error, params.get("error_description"))
      } else {
        auth0Client.handleRedirectCallback().then(() => {
          auth0Client.getUser().then(user => {
            app.config.globalProperties.currentUser = user;
          })

          router.replace("/") // we don't want user to get here when "Back" button is clicked.
        })
      }
    } else {
      next()
    }
  })

  // avoid unnecessary redirect (authorize->callback) in case user is already authorized and SPA is reloaded
  auth0Client.getUser().then(user => {
    app.config.globalProperties.currentUser = user;

    app.use(router).use(VueAxios, axios).use(bugsnagVue).mount('#app');
  });
});
